var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fill-height":""}},[_c('img',{attrs:{"src":require("@/assets/innotix-logo.png"),"alt":"InnoTix"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }